module.exports = __webpack_public_path__ + "public/images/splotches.65feb4a3de92c705084c541949b3800c.png";